import React from 'react'
import { Link } from 'gatsby'
import Layout from '../../components/layout'
import Carousel from '../../components/carousel'

const data = require('../../xml/yellology.json');

const Yellobook = () => {
  const article = data.root.yellobook;

  let articleHtml = article.copy;
  articleHtml = articleHtml.replace(/\<p>/g, '');
  articleHtml = articleHtml.replace(/\<br><br>/g, '</p><p>');
  articleHtml = articleHtml.replace(/<br>/g, '<br/>');

  const images = article.images.image.map(x => ({
    url: x['$t'],
    caption: x.caption
  }));

  return (
    <Layout>
      <div className="lightboxcolumn">
        <Carousel images={images} />
      </div>
      <div className="narrowcontentcolumn">
        <header>
          <div className="close">
            <Link to={'/empty/'} alt="Close">Close<img src="/img/x.gif" /></Link>
          </div>
          <h3>
            YELLO book<br/>
          </h3>
        </header>
        <div className="narrowcontent">
          <div className="inner">
            <h2 className="mobile-only">YELLO BOOK<br/>&#8211;</h2>
            <div dangerouslySetInnerHTML={{ __html: articleHtml }}></div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Yellobook
